import { useRef, useEffect } from 'react'
import { Search, X } from 'lucide-react'
import { useDashboardStore } from '../stores/dashboardStore'

export function SearchBar() {
  const inputRef = useRef<HTMLInputElement>(null)
  const searchQuery = useDashboardStore((s) => s.searchQuery)
  const setSearchQuery = useDashboardStore((s) => s.setSearchQuery)

  // Cmd+K shortcut
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault()
        inputRef.current?.focus()
      }
    }
    document.addEventListener('keydown', handler)
    return () => document.removeEventListener('keydown', handler)
  }, [])

  return (
    <div className="relative w-full">
      <Search
        size={14}
        className={`absolute left-2.5 top-1/2 -translate-y-1/2 pointer-events-none ${searchQuery ? 'text-emerald-500' : 'text-gray-400'}`}
      />
      <input
        ref={inputRef}
        type="text"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            setSearchQuery('')
            inputRef.current?.blur()
          }
        }}
        placeholder="Søk ordrer... ⌘K"
        className={`w-full py-1.5 pl-8 pr-8 border rounded-md text-[13px] text-gray-900 placeholder:text-gray-400 transition-[border-color,box-shadow] focus:outline-none focus:border-emerald-500 focus:ring-[3px] focus:ring-emerald-500/12 focus:bg-white ${searchQuery ? 'border-emerald-400 bg-emerald-50/50' : 'border-gray-300 bg-gray-50'}`}
      />
      {searchQuery && (
        <button
          onClick={() => {
            setSearchQuery('')
            inputRef.current?.focus()
          }}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
        >
          <X size={14} />
        </button>
      )}
    </div>
  )
}
